<div class="final-report-container" data-cy="finalreport-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="finalreport-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="finalreport-header">
      <div class="section-header-title" data-cy="finalreport-title">
        Final Report
      </div>
      <div style="flex: 1;"></div>
    </div>
    @if (isLoading) {
      <app-tdo-progress-spinner class="spinner" style="flex: 1;" data-cy="finalreport-spinner"></app-tdo-progress-spinner>
    }
    <!--  MAIN AREA-->
    @if (!isLoading) {
    <div class="section-content ui-dark-background"
      style="padding: 2px; flex: 1; margin-top: 6px; background-color: var(--tdo-background); overflow: hidden;">
      
        <div style="display: flex; max-height: 100%; overflow-y: hidden;">
          <div style="margin-right: 3px; flex-basis: 50%; border-radius: var(--border-radius); display: flex; flex-direction: column; height: fit-content;">
            <div class="final-report-left-cell" style="flex-basis: fit-content;">
              <table style="width: 100%; ">
                <tr>
                  <td class="final-report-gen-info-cell-one">Case:</td>
                  <td class="final-report-gen-info-cell-two" colspan="2" >{{patientCaseModel?.Description}}</td>
                  <td class="final-report-gen-info-cell-four" colspan="2">
                    <mat-checkbox [ngModel]="!finalReportModel.isReportNeede" (change)="reportNeededChecked($event)">
                      No Report Needed
                    </mat-checkbox>
                  </td>
                  <td class="final-report-gen-info-cell-five" ></td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Tooth:</td>
                  <td class="final-report-gen-info-cell-two" colspan="2">{{toothName}}</td>
                  <td class="final-report-gen-info-cell-tree"></td>
                  <td class="final-report-gen-info-cell-four"></td>
                  <td class="final-report-gen-info-cell-five" ></td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Case Status:</td>
                  <td class="final-report-gen-info-cell-two" colspan="2">
                    <app-tdo-enum-select zVersion="B2s" name="enumFinalReportCaseStatus"
                      [validValueItemId]="finalReportModel.enumFinalReportCaseStatusID"
                      (enumSelected)="onCaseStatusChange($event)"
                      (isUserInput)="setUserInput($event)"
                      [selectHeight]="22"
                    displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                  </td>
                  <td class="final-report-gen-info-cell-four" colspan="2">
                    <tdo-date-input widthString="160px" [valueAsDate]="getCompletedDate()" [isAllowBlank]="true" (dateChanged)="onCompletedDateChange($event)" data-cy="finalreport-case-status-date-input"></tdo-date-input>
                  </td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Prognosis:</td>
                  <td class="final-report-gen-info-cell-two" >
                    <app-tdo-enum-select zVersion="B2s" name="enumFinalReportPrognosis"
                      [validValueItemId]="finalReportModel.enumFinalReportPrognosisID"
                      (enumSelected)="FinalReportPrognosisSelected($event);"
                      (isUserInput)="setUserInput($event)"
                    displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                  </td>
                  <td class="final-report-gen-info-cell-tree" style="text-align: right">Type:</td>
                  <td class="final-report-gen-info-cell-four" colspan="2">
                    <app-tdo-enum-select zVersion="B2s" name="enumCaseType"
                      [validValueItemId]="finalReportModel.enumCaseTypeID"
                      (enumSelected)="finalReportModel.enumCaseTypeID = $event.ValidValueItemId; saveChanges()"
                      (isUserInput)="setUserInput($event)"
                    displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                  </td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Recall:</td>
                  <td class="final-report-gen-info-cell-two" >
                    <app-tdo-enum-select zVersion="B2s" name="enumFinalReportRecall"
                      [validValueItemId]="finalReportModel.enumFinalReportRecallID"
                      (enumSelected)="onRecallTimeChange($event)"
                      (isUserInput)="setUserInput($event)"
                    displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                  </td>
                  <td class="final-report-gen-info-cell-tree" colspan="2">
                    {{getDateFromModel(finalReportModel.RecallDate) | date: 'EEE MMM dd, yyyy'}}
                  </td>
                  <td class="final-report-gen-info-cell-five">
                    <mat-checkbox [ngModel]="finalReportModel.isSuperRecall"
                      (change)="finalReportModel.isSuperRecall = $event.checked; this.isUserInput = true; saveChanges()"
                      style="margin-top: 5px;">Super
                    </mat-checkbox>
                  </td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Refer To:</td>
                  <td class="final-report-gen-info-cell-two" colspan="2">
                    <tdo-dropdown-v2 zVersion="B2s" [datasource]="nonGpDoctors"
                      [value]="getDoctor(nonGpDoctors, finalReportModel.RefereToDoctorID)"
                      [displayPredicate]="doctorDisplayPredicate"
                    (selectionChange)="$event.value ? referrToDoctorSelected($event) : log('undefined referrToDoctorSelected value', $event)"></tdo-dropdown-v2>
                  </td>
                  <td style="width: 25%"></td>
                  <td class="final-report-gen-info-cell-four" >
                    <mat-checkbox [ngModel]="patientData.isDoNotEverTreatAgain"
                      (change)="patientData.isDoNotEverTreatAgain = $event.checked; this.isUserInput = true; savePatientDNETA()">
                      DNETA
                    </mat-checkbox>
                  </td>
                </tr>
                <tr>
                  <td class="final-report-gen-info-cell-one">Refer To GP:</td>
                  <td class="final-report-gen-info-cell-two" colspan="2">
                    <tdo-dropdown-v2 zVersion="B2s" [datasource]="gpDoctors"
                      [value]="getDoctor(gpDoctors, finalReportModel.RefereToGPDoctorID)"
                      [displayPredicate]="doctorDisplayPredicate"
                    (selectionChange)="$event.value ? referrToGPDoctorSelected($event) : log('undefined referrToGPDoctorSelected value', $event)"></tdo-dropdown-v2>
                  </td>
                  <td class="final-report-gen-info-cell-tree"></td>
                  <td class="final-report-gen-info-cell-four"></td>
                </tr>
              </table>
            </div>
            <div class="final-report-left-cell" style="display: block;" data-cy="finalreport-recommendations-section">
              <span style="font-weight: 500;" data-cy="finalreport-recommendations-title">Restorative Recommendations</span><br/>
              <div style="margin-top: 10px; display: flex; flex-wrap: wrap; overflow-y: auto; height: 115px;"
                (contextmenu)="onRightMouseClick($event, restorationMethodEnums)"
                data-cy="finalreport-recommendations-list">
                @for (rec of restorationMethodEnums; track rec) {
                  <div style="min-width: 120px; margin-right: 6px;" data-cy="finalreport-recommendation-item">
                    <mat-checkbox style="height: 20px;" [checked]="isRestorationChecked(rec)"
                    (change)="onRestorationChange($event, rec)" data-cy="finalreport-recommendation-checkbox">{{rec.ItemDisplayValue}}</mat-checkbox>
                  </div>
                }
              </div>
              <div style="display: flex; margin-top: 5px;" data-cy="finalreport-other-section">
                <mat-checkbox [checked]="isRestContainsOther()" (change)="onRestOtherChange($event)" data-cy="finalreport-other-checkbox">Other:</mat-checkbox>
                <div style="margin-left: 6px; flex: 1;">
                  <input (appInputFinished)="onOtherInputFinished($event)" [ngModel]="getOther()?.OtherInText"
                    style=" width: 100%; border-width: 1px ; border-radius: var(--border-radius); " data-cy="finalreport-other-input"/>
                  </div>
                  <button style="margin-left: 6px; position: relative; top: -6px;" (click)="onClearRest()"
                    class="tdo-button tdo-save" data-cy="finalreport-clear-recommendations-button">Clear
                  </button>
                </div>
              </div>
              <div
                style="display: flex; flex-basis: 30px; max-height: 40px; background-color: white; border-radius: var(--border-radius); padding: 4px 4px 0 4px; margin-bottom: 8px;">
                <div style="flex: 1; display: flex; margin-right: 6px;">
                  <span style="font-weight: 500;">Treatment sessions:</span>
                  <div style="flex: 1; position: relative; top: -3px; margin-left: 3px;" class="final-report-dropdown">
                    <app-tdo-enum-select zVersion="B2s" name="enumTreatmentSessions" placeholder=""
                      [validValueItemId]="finalReportModel.enumTreatmentSessionsID"
                      (enumSelected)="finalReportModel.enumTreatmentSessionsID = $event.ValidValueItemId; saveChanges()"
                      (isUserInput)="setUserInput($event)"
                      displayProperty="ItemDisplayValue"
                    ></app-tdo-enum-select>
                  </div>
                </div>
                <div style="flex: 1; display: flex; margin-left: 6px; margin-right: 4px;">
                  <span style="font-weight: 500;">Case rating:</span>
                  <div style="flex: 1; position: relative; top: -3px; margin-left: 3px;" class="final-report-dropdown">
                    <app-tdo-enum-select zVersion="B2s"  name="enumCaseRating" placeholder=""
                      [validValueItemId]="finalReportModel.enumCaseRatingID"
                      (enumSelected)="finalReportModel.enumCaseRatingID = $event.ValidValueItemId; saveChanges()"
                      (isUserInput)="setUserInput($event)"
                    displayProperty="ItemDisplayValue"></app-tdo-enum-select>
                  </div>
                </div>
              </div>
              <div
                style="flex-basis: 140px; background-color: white; border-radius: var(--border-radius); padding: 8px 4px 0 4px; margin-bottom: 6px; overflow-y: hidden;" data-cy="finalreport-referral-section">
                <span style="font-weight: 500" data-cy="finalreport-referral-title">Referral Reports</span>
                <div style="display: flex; flex-wrap: wrap; overflow-y: auto; height: 65px;" data-cy="finalreport-referral-list">
                  @for (report of reports; track report) {
                    <div class="final-report-referral-item" data-cy="finalreport-referral-item">
                      <mat-checkbox [checked]="isRefChecked(report)"
                        [disabled]="!finalReportModel.isReportNeede"
                      (change)="onReportsChange($event, report)" data-cy="finalreport-referral-checkbox">{{report.ReportName}}</mat-checkbox>
                    </div>
                  }
                </div>
                <div style="display: flex;">
                  <div style="flex: 1;"></div>
                  <button class="tdo-button tdo-save" (click)="onClearReferralReports()" [disabled]="!finalReportModel.isReportNeede" data-cy="finalreport-clear-referrals-button">Clear</button>
                </div>
              </div>
              <div style="display: flex; flex-basis: 50px; background-color: white; border-radius: var(--border-radius); padding: 8px 4px 0 4px; margin-bottom: 6px; overflow-y: hidden;" data-cy="finalreport-diagnostics-section">
                <mat-checkbox style="margin-right: 12px;" [checked]="finalReportModel.isSendDiagnostics"
                  (change)="finalReportModel.isSendDiagnostics = $event.checked; this.isUserInput = true;  saveChanges()" data-cy="finalreport-diagnostics-checkbox">
                  Diagnostic Report
                </mat-checkbox>
                <mat-radio-group [disabled]="!finalReportModel.isSendDiagnostics"
                  [value]="finalReportModel.isDiagnosticsLarge" aria-label="Select an option" data-cy="finalreport-diagnostics-size">
                  <mat-radio-button style="margin-right: 6px;" [value]="false"
                    (change)="finalReportModel.isDiagnosticsLarge = false; this.isUserInput = true;  saveChanges()" data-cy="finalreport-diagnostics-small">
                    Small
                  </mat-radio-button>
                  <mat-radio-button [value]="true"
                    (change)="finalReportModel.isDiagnosticsLarge = true; this.isUserInput = true; saveChanges()" data-cy="finalreport-diagnostics-large">
                    Large
                  </mat-radio-button>
                </mat-radio-group>
                <div style="flex: 1;"></div>
                <button style="position: relative; top: -6px;" class="tdo-button tdo-save" (click)="onOpenLetters()" data-cy="finalreport-mail-preset-button">Mail Preset
                </button>
              </div>
            </div>
            <div
              style="margin-left: 3px; flex-basis: 50%; border-radius: var(--border-radius); display: flex; flex-direction: column;" data-cy="finalreport-right-panel">
              <!--          RIGHT-->
              <div
                style="background-color: white; border-bottom: 6px; display: flex; flex-direction: column; padding: 6px; margin-bottom: 6px; border-radius: var(--border-radius);" data-cy="finalreport-notes-section">
                <div style="flex-basis: 420px; min-width: 440px; height: calc(80% ); margin-right: var(--margin-size); " data-cy="finalreport-notes-container">
                  <div style="font-weight: 500;" data-cy="finalreport-notes-title">Final Notes for Referral Report</div>
                  <div style="height: 95%; margin-bottom: var(--margin-size); overflow: hidden;" data-cy="finalreport-notes-editor">
                    <app-tdo-simple-note height="100%" [numRows]="5" #simpleNote [categoryEnumId]="noteFind.categoryEnumId"
                      [typeEnumId]="noteFind.typeEnumId" [PatientId]="noteModel?.patientId"
                    [parentObjectName]="dataPatientCaseEndoFinalReport" [objectId]="finalReportModel?.CaseFinalReportID"></app-tdo-simple-note>
                  </div>
                </div>
              </div>
              <div
                style="background-color: white; border-bottom: 6px; display: flex; flex-direction: column; padding: 6px; flex: 1; margin-bottom: 6px; border-radius: var(--border-radius);" data-cy="finalreport-status-section">
                <span style="font-weight: 500;" data-cy="finalreport-status-title">Referral Report Status</span>
                <div
                  style="display: flex; flex-direction: column; overflow-y: scroll; margin-top: 8px; flex: 1; padding: 8px; max-height: 60%;" data-cy="finalreport-status-list">
                  @for (ref of finalReportModel.dataPatientCaseEndoFinalReportReferrReps; track ref) {
                    <div
                      style="display: flex; margin-bottom: 1px;" data-cy="finalreport-status-item">
                      <div style="flex: 1; display: flex;" data-cy="finalreport-status-to">
                        <span>To:</span>
                        <input [value]="SentToLabel" [disabled]="true" class="inputReport" data-cy="finalreport-status-to-value"/>
                      </div>
                      <div style="flex: 1; display: flex;" data-cy="finalreport-status-date">
                        <span>Date:</span>
                        <input [value]="ref.SentDate | date:'medium'" [disabled]="true" class="inputReport" data-cy="finalreport-status-date-value"/>
                      </div>
                      <div style="flex: 1; display: flex;" data-cy="finalreport-status-report">
                        <span>Report:</span>
                        <input [value]="getReportName(ref.ReportID)" [disabled]="true" class="inputReport" data-cy="finalreport-status-report-value"/>
                      </div>
                    </div>
                  }
                </div>
                <div style="display: flex;">
                  <div style="flex: 1;"></div>
                  <button (click)="sendFinalReport()" class="tdo-button tdo-save" style="margin-top: 8px;" data-cy="finalreport-submit-button">Submit/Save</button>
                </div>
              </div>
            </div>
          </div>
      </div>
    }
    </div>

    <ng-template #enumOptionsMenu let-data data-cy="finalreport-enum-options-menu">
      <section style="border: 1px solid var(--tdo-secondary);" class="context-menu" data-cy="finalreport-context-menu">
        <div (click)="onEditList()" class="item" style="color: black;" data-cy="finalreport-edit-list-button">Edit List</div>
      </section>
    </ng-template>
  </div>
